import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`
